var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assignee-wrap"},[_c('span',{staticClass:"user-profile"},[_c('img',{attrs:{"src":_vm.userDetail(),"alt":"user profile"}})]),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"assignee-name",attrs:{"title":_vm.id}},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }